import { render, staticRenderFns } from "./PrecificationModal.vue?vue&type=template&id=166ae9ca"
import script from "./PrecificationModal.vue?vue&type=script&lang=js"
export * from "./PrecificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports